module.exports = __webpack_public_path__ + "assets/img/cap.svg";